import * as i0 from "@angular/core";
export class DashboardHomeStore {
}
DashboardHomeStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardHomeStore_Factory() { return new DashboardHomeStore(); }, token: DashboardHomeStore, providedIn: "root" });
export var DashboardHomeStoreKeys;
(function (DashboardHomeStoreKeys) {
})(DashboardHomeStoreKeys || (DashboardHomeStoreKeys = {}));
